Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseStyles = void 0;

var get_responsive_prop_1 = require("./lib/get-responsive-prop");

var parse_prop_1 = require("./lib/parse-prop");

var recursiveParse = function recursiveParse(_ref) {
  var config = _ref.config,
      theme = _ref.theme,
      props = _ref.props,
      result = _ref.result;

  var _loop = function _loop() {
    var name = _Object$keys[_i];

    if (typeof props[name] === 'object' && props[name] !== null && !Array.isArray(props[name])) {
      result[name] = {};
      recursiveParse({
        config: config,
        props: props[name],
        result: result[name],
        theme: theme
      });
      return "continue";
    }

    if (name in config.propertyAliases) {
      config.propertyAliases[name].forEach(function (fullPropName) {
        var propWithMediaQueries = parse_prop_1.parseProp({
          config: config,
          name: fullPropName,
          theme: theme,
          value: props[name]
        });
        get_responsive_prop_1.mergeInMediaQuery({
          result: result,
          propWithMediaQueries: propWithMediaQueries
        });
      });
    } else {
      var propWithMediaQueries = parse_prop_1.parseProp({
        config: config,
        name: name,
        theme: theme,
        value: props[name]
      });
      get_responsive_prop_1.mergeInMediaQuery({
        result: result,
        propWithMediaQueries: propWithMediaQueries
      });
    }
  };

  for (var _i = 0, _Object$keys = Object.keys(props); _i < _Object$keys.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }
};

exports.parseStyles = function (_ref2) {
  var config = _ref2.config,
      theme = _ref2.theme,
      props = _ref2.props;
  var result = {};
  recursiveParse({
    config: config,
    theme: theme,
    props: props,
    result: result
  });
  return result;
};